export default "__VITE_PUBLIC_ASSET__750d3aa1__"